import { type FC } from 'react';
import { AnimatePresence, cubicBezier, motion } from 'framer-motion';

import { createBgSet } from '@/common/lib/createBgSet';

import { lotteryBackgroundList } from '../../config';
import { useCurrentLotteryTier } from '../../hooks';

const Background: FC = () => {
  const currentTicketType = useCurrentLotteryTier();

  const bgImageBase = `
    linear-gradient(270deg, #181A20 0%, rgba(24, 26, 32, 0.00) 12.5%),
    linear-gradient(270deg, rgba(24, 26, 32, 0.00) 87.5%, #181A20 100%),
    linear-gradient(180deg, rgba(24, 26, 32, 0.00) 71.63%, #181A20 100%),
  `;

  return (
    <AnimatePresence>
      {lotteryBackgroundList.map(({ name, png, webp }) => {
        const isActive = currentTicketType === name;

        return (
          <motion.div
            key={name}
            initial={{ opacity: 0 }}
            animate={{ opacity: isActive ? 1 : 0 }}
            exit={{ opacity: 0 }}
            style={{ backgroundImage: bgImageBase + createBgSet(png, webp) }}
            transition={{
              ease: cubicBezier(0.34, 1.56, 0.64, 1),
              duration: 0.2,
            }}
            className="aspect-square mix-blend-lighten absolute top-0 left-0 w-full bg-cover bg-no-repeat"
          ></motion.div>
        );
      })}
    </AnimatePresence>
  );
};

export { Background };
